import React from 'react'

function Size() {
  return (
<>
<h2>Size (height and width)</h2>
<br/>
<h6>Height percentage</h6>
<p className='p-doc'>applicable values</p>
<code>10, 25, 50, 75, 100</code>
<br/>
<code>h-per-[value]</code>

<br/>
<br/>
<h6>Width percentage</h6>
<p className='p-doc'>applicable values</p>
<code>10, 25, 50, 75, 100</code>
<br/>
<code>w-per-[value]</code>

<br/>
<br/>
<h6>fit-content</h6>
<code>h-fit</code>
<br/>
<code>w-fit</code>
</>
    )
}

export default Size